// import React, { useState } from 'react'
// import PricingCard from '../Cart/PricingCard'
// import { Box, Button, FormControl, FormControlLabel, FormLabel, Modal, Radio, RadioGroup } from '@mui/material'
// import { useNavigate } from 'react-router-dom'
// import AddressForm from './AddresssForm'
// import AddressCard from './AddressCard'
// import AddIcon from '@mui/icons-material/Add';
// import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice'
// import { Address } from '../../../types/userTypes'
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store'
// import userEvent from '@testing-library/user-event'

// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 450,
//     bgcolor: 'background.paper',
//     boxShadow: 24,
//     p: 4,
// };

// const paymentGatwayList = [
//     {
//         value: "RAZORPAY",
//         image: "https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png",
//         label: "Razarpay"
//     },
//     // {
//     //     value: "STRIPE",
//     //     image: "/stripe_logo.png",
//     //     label: "Stripe"
//     // }
// ]
// const AddressPage = () => {
//     const navigate = useNavigate()
//     const [value, setValue] = React.useState(0);
//     const dispatch = useAppDispatch();
//     const { user } = useAppSelector(store => store)
//     const [paymentGateway, setPaymentGateway] = useState(paymentGatwayList[0].value);

//     const [open, setOpen] = React.useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     const handleChange = (event: any) => {
//         console.log("-----", event.target.value)
//         setValue(event.target.value);
//     };

//     const handleCreateOrder = () => {
//         if (user.user?.addresses)
//             dispatch(createOrder({
//                 paymentGateway,
//                 address: user.user?.addresses[value],
//                 jwt: localStorage.getItem('jwt') || ""
//             }))
//     }

//     const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//         setPaymentGateway((event.target as HTMLInputElement).value);
//     };

//     return (
//         <div className='pt-10 px-5 sm:px-10 md:px-44 lg:px-60 min-h-screen '>
//             <div className='space-y-5 lg:space-y-0 lg:grid grid-cols-3 lg:gap-9 '>

//                 <div className="col-span-2 space-y-5">

//                     <div className='flex justify-between items-center'>
//                         <span className='font-semibold'>Select Delivery Address</span>
//                         <Button onClick={handleOpen} variant='outlined'>Add New Address</Button>

//                     </div>
//                     <div className='text-xs font-medium space-y-5'>
//                         <p>Saved Address</p>
//                         <div className='space-y-3'>
//                             {user.user?.addresses?.map((item, index) => <AddressCard
//                                 key={item.id}
//                                 item={item}
//                                 selectedValue={value} value={index}
//                                 handleChange={handleChange} />)}
//                         </div>
//                     </div>
//                     <div className='py-4 px-5 rounded-md border'>

//                         <Button onClick={handleOpen} startIcon={<AddIcon />}>Add New Address</Button>

//                     </div>
//                 </div>
//                 <div className="col-span-1 text-sm space-y-3 ">
//                     <section className='space-y-3 border p-5 rounded-md'>
//                         <h1 className='text-primary-color font-medium pb-2 text-center'>Choose Payment Gatway</h1>

//                         <RadioGroup
//                             row
//                             aria-labelledby="demo-row-radio-buttons-group-label"
//                             name="row-radio-buttons-group"
//                             className='flex justify-between pr-0'
//                             onChange={handlePaymentChange}
//                             value={paymentGateway}

//                         >
//                             {paymentGatwayList.map((item) => <FormControlLabel className={`border w-[45%] flex justify-center rounded-md pr-2 ${paymentGateway === item.value ? "border-primary-color" : ""}`} value={item.value} control={<Radio />} label={<div>

//                                 <img
//                                     className={`${item.value == "stripe" ? "w-14" : ""} object-cover`}
//                                     src={item.image}
//                                     alt={item.label}
//                                 />
//                             </div>} />)}


//                         </RadioGroup>

//                     </section>
//                     <section className='border rounded-md'>
//                         <PricingCard />
//                         <div className='p-5'>
//                             <Button
//                                 onClick={handleCreateOrder} sx={{ py: "11px" }}
//                                 variant='contained' fullWidth>Checkout</Button>
//                         </div>
//                     </section>

//                 </div>

//             </div>

//             <Modal
//                 open={open}
//                 onClose={handleClose}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//             >
//                 <Box sx={style}>
//                     <AddressForm paymentGateway={paymentGateway} handleClose={handleClose} />
//                 </Box>
//             </Modal>
//         </div>
//     )
// }

// export default AddressPage

// import React, { useEffect, useState } from 'react'
// import PricingCard from '../Cart/PricingCard'
// import { Box, Button, FormControl, FormControlLabel, FormLabel, Modal, Radio, RadioGroup } from '@mui/material'
// import { useNavigate } from 'react-router-dom'
// import AddressForm from './AddresssForm'
// import AddressCard from './AddressCard'
// import AddIcon from '@mui/icons-material/Add';
// import { createOrder } from '../../../Redux Toolkit/Customer/OrderSlice'
// import { Address } from '../../../types/userTypes'
// import { useAppDispatch, useAppSelector } from '../../../Redux Toolkit/Store'
// import userEvent from '@testing-library/user-event'
// import { trackEvent } from '../../../util/analytics'

// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 450,
//     bgcolor: 'background.paper',
//     boxShadow: 24,
//     p: 4,
// };

// const paymentGatwayList = [
//     {
//         value: "RAZORPAY",
//         image: "https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png",
//         label: "Razarpay"
//     },
//     // {
//     //     value: "STRIPE",
//     //     image: "/stripe_logo.png",
//     //     label: "Stripe"
//     // }
// ]
// const AddressPage = () => {
//     const navigate = useNavigate()
//     const [value, setValue] = React.useState(0);
//     const dispatch = useAppDispatch();
//     const { user } = useAppSelector(store => store)
//     const [paymentGateway, setPaymentGateway] = useState(paymentGatwayList[0].value);

//     const [open, setOpen] = React.useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);

//     useEffect(() => {
//         trackEvent("CHECKOUT_VIEW", {
//             page: "/checkout/address",
//         });
//     }, []);

//     const handleChange = (event: any) => {
//         console.log("-----", event.target.value)
//         setValue(event.target.value);
//     };

//     const handleCreateOrder = () => {
//         if (user.user?.addresses)
//             dispatch(createOrder({
//                 paymentGateway,
//                 address: user.user?.addresses[value],
//                 jwt: localStorage.getItem('jwt') || ""
//             }))
//     }

//     const handlePaymentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//         setPaymentGateway((event.target as HTMLInputElement).value);
//     };

//     return (
//         <div className='pt-10 px-5 sm:px-10 md:px-44 lg:px-60 min-h-screen '>
//             <div className='space-y-5 lg:space-y-0 lg:grid grid-cols-3 lg:gap-9 '>

//                 <div className="col-span-2 space-y-5">

//                     <div className='flex justify-between items-center'>
//                         <span className='font-semibold'>Select Delivery Address</span>
//                         <Button onClick={handleOpen} variant='outlined'>Add New Address</Button>

//                     </div>
//                     <div className='text-xs font-medium space-y-5'>
//                         <p>Saved Address</p>
//                         <div className='space-y-3'>
//                             {user.user?.addresses?.map((item, index) => <AddressCard
//                                 key={item.id}
//                                 item={item}
//                                 selectedValue={value} value={index}
//                                 handleChange={handleChange} />)}
//                         </div>
//                     </div>
//                     <div className='py-4 px-5 rounded-md border'>

//                         <Button onClick={handleOpen} startIcon={<AddIcon />}>Add New Address</Button>

//                     </div>
//                 </div>
//                 <div className="col-span-1 text-sm space-y-3 ">
//                     <section className='space-y-3 border p-5 rounded-md'>
//                         <h1 className='text-primary-color font-medium pb-2 text-center'>Choose Payment Gatway</h1>

//                         <RadioGroup
//                             row
//                             aria-labelledby="demo-row-radio-buttons-group-label"
//                             name="row-radio-buttons-group"
//                             className='flex justify-between pr-0'
//                             onChange={handlePaymentChange}
//                             value={paymentGateway}

//                         >
//                             {paymentGatwayList.map((item) => <FormControlLabel className={`border w-[45%] flex justify-center rounded-md pr-2 ${paymentGateway === item.value ? "border-primary-color" : ""}`} value={item.value} control={<Radio />} label={<div>

//                                 <img
//                                     className={`${item.value == "stripe" ? "w-14" : ""} object-cover`}
//                                     src={item.image}
//                                     alt={item.label}
//                                 />
//                             </div>} />)}


//                         </RadioGroup>

//                     </section>
//                     <section className='border rounded-md'>
//                         <PricingCard />
//                         <div className='p-5'>
//                             <Button
//                                 onClick={handleCreateOrder} sx={{ py: "11px" }}
//                                 variant='contained' fullWidth>Checkout</Button>
//                         </div>
//                     </section>

//                 </div>

//             </div>

//             <Modal
//                 open={open}
//                 onClose={handleClose}
//                 aria-labelledby="modal-modal-title"
//                 aria-describedby="modal-modal-description"
//             >
//                 <Box sx={style}>
//                     <AddressForm paymentGateway={paymentGateway} handleClose={handleClose} />
//                 </Box>
//             </Modal>
//         </div>
//     )
// }

// export default AddressPage


// import React, { useEffect, useState } from "react";
// import PricingCard from "../Cart/PricingCard";
// import {
//     Box,
//     Button,
//     FormControlLabel,
//     Modal,
//     Radio,
//     RadioGroup,
// } from "@mui/material";
// import AddressForm from "./AddresssForm";
// import AddressCard from "./AddressCard";
// import AddIcon from "@mui/icons-material/Add";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { trackEvent } from "../../../util/analytics";

// const style = {
//     position: "fixed" as const,
//     top: "52%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "calc(100% - 24px)",
//     maxWidth: "620px",
//     outline: "none",
//     bgcolor: "transparent",
//     boxShadow: "none",
//     p: 0,
//     overflow: "hidden",
// };

// const paymentGatwayList = [
//     {
//         value: "RAZORPAY",
//         image:
//             "https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png",
//         label: "Razarpay",
//     },
// ];

// const AddressPage = () => {
//     const [value, setValue] = React.useState(0);
//     const dispatch = useAppDispatch();
//     const { user } = useAppSelector((store) => store);
//     const [paymentGateway, setPaymentGateway] = useState(
//         paymentGatwayList[0].value
//     );

//     const [open, setOpen] = React.useState(false);

//     const handleOpen = () => {
//         setOpen(true);
//         document.body.style.overflow = "hidden";
//     };

//     const handleClose = () => {
//         setOpen(false);
//         document.body.style.overflow = "";
//     };

//     useEffect(() => {
//         trackEvent("CHECKOUT_VIEW", {
//             page: "/checkout/address",
//         });

//         return () => {
//             document.body.style.overflow = "";
//         };
//     }, []);

//     const handleChange = (event: any) => {
//         setValue(Number(event.target.value));
//     };

//     const handleCreateOrder = () => {
//         if (user.user?.addresses) {
//             dispatch(
//                 createOrder({
//                     paymentGateway,
//                     address: user.user?.addresses[value],
//                     jwt: localStorage.getItem("jwt") || "",
//                 })
//             );
//         }
//     };

//     const handlePaymentChange = (
//         event: React.ChangeEvent<HTMLInputElement>
//     ) => {
//         setPaymentGateway((event.target as HTMLInputElement).value);
//     };

//     return (
//         <div className="min-h-screen px-5 pt-10 sm:px-10 md:px-44 lg:px-60">
//             <div className="space-y-5 lg:grid lg:grid-cols-3 lg:gap-9 lg:space-y-0">
//                 <div className="col-span-2 space-y-5">
//                     <div className="flex items-center justify-between">
//                         <span className="font-semibold">Select Delivery Address</span>

//                         <Button onClick={handleOpen} variant="outlined">
//                             Add New Address
//                         </Button>
//                     </div>

//                     <div className="space-y-5 text-xs font-medium">
//                         <p>Saved Address</p>

//                         <div className="space-y-3">
//                             {user.user?.addresses?.map((item, index) => (
//                                 <AddressCard
//                                     key={item.id}
//                                     item={item}
//                                     selectedValue={value}
//                                     value={index}
//                                     handleChange={handleChange}
//                                 />
//                             ))}
//                         </div>
//                     </div>

//                     <div className="rounded-md border px-5 py-4">
//                         <Button onClick={handleOpen} startIcon={<AddIcon />}>
//                             Add New Address
//                         </Button>
//                     </div>
//                 </div>

//                 <div className="col-span-1 space-y-3 text-sm">
//                     <section className="space-y-3 rounded-md border p-5">
//                         <h1 className="pb-2 text-center font-medium text-primary-color">
//                             Choose Payment Gatway
//                         </h1>

//                         <RadioGroup
//                             row
//                             name="payment-gateway"
//                             className="flex justify-between pr-0"
//                             onChange={handlePaymentChange}
//                             value={paymentGateway}
//                         >
//                             {paymentGatwayList.map((item) => (
//                                 <FormControlLabel
//                                     key={item.value}
//                                     className={`flex w-[45%] justify-center rounded-md border pr-2 ${paymentGateway === item.value
//                                             ? "border-primary-color"
//                                             : ""
//                                         }`}
//                                     value={item.value}
//                                     control={<Radio />}
//                                     label={
//                                         <div>
//                                             <img
//                                                 className="object-cover"
//                                                 src={item.image}
//                                                 alt={item.label}
//                                             />
//                                         </div>
//                                     }
//                                 />
//                             ))}
//                         </RadioGroup>
//                     </section>

//                     <section className="rounded-md border">
//                         <PricingCard />

//                         <div className="p-5">
//                             <Button
//                                 onClick={handleCreateOrder}
//                                 sx={{ py: "11px" }}
//                                 variant="contained"
//                                 fullWidth
//                             >
//                                 Checkout
//                             </Button>
//                         </div>
//                     </section>
//                 </div>
//             </div>

//             <Modal
//                 open={open}
//                 onClose={handleClose}
//                 disableScrollLock
//                 aria-labelledby="add-address-modal"
//                 aria-describedby="add-address-form"
//             >
//                 <Box sx={style}>
//                     <AddressForm
//                         paymentGateway={paymentGateway}
//                         handleClose={handleClose}
//                     />
//                 </Box>
//             </Modal>
//         </div>
//     );
// };

// export default AddressPage;


// import React, { useEffect, useState } from "react";
// import PricingCard from "../Cart/PricingCard";
// import {
//   Box,
//   Button,
//   FormControlLabel,
//   Modal,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import AddressForm from "./AddresssForm";
// import AddressCard from "./AddressCard";
// import AddIcon from "@mui/icons-material/Add";
// import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { fetchUserAddresses } from "../../../Redux Toolkit/Customer/UserSlice";

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: { xs: "92%", sm: 450 },
//   maxHeight: "90vh",
//   overflowY: "auto",
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   p: 4,
// };

// const paymentGatwayList = [
//   {
//     value: "RAZORPAY",
//     image:
//       "https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png",
//     label: "Razarpay",
//   },
// ];

// const AddressPage = () => {
//   const navigate = useNavigate();
//   const dispatch = useAppDispatch();

//   const { user } = useAppSelector((store) => store);

//   const addresses =
//     user.addresses && user.addresses.length > 0
//       ? user.addresses
//       : user.user?.addresses || [];

//   const defaultAddressIndex = addresses.findIndex(
//     (address) => address.defaultAddress
//   );

//   const [value, setValue] = useState(defaultAddressIndex >= 0 ? defaultAddressIndex : 0);
//   const [paymentGateway, setPaymentGateway] = useState(
//     paymentGatwayList[0].value
//   );
//   const [open, setOpen] = useState(false);

//   useEffect(() => {
//     dispatch(fetchUserAddresses());
//   }, [dispatch]);

//   useEffect(() => {
//     const newDefaultAddressIndex = addresses.findIndex(
//       (address) => address.defaultAddress
//     );

//     if (newDefaultAddressIndex >= 0) {
//       setValue(newDefaultAddressIndex);
//     } else if (addresses.length > 0 && value >= addresses.length) {
//       setValue(0);
//     }
//   }, [addresses.length]);

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);

//   const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
//     setValue(Number(event.target.value));
//   };

//   const handleCreateOrder = () => {
//     const selectedAddress = addresses[value];

//     if (!selectedAddress) {
//       return;
//     }

//     dispatch(
//       createOrder({
//         paymentGateway,
//         address: selectedAddress,
//         jwt: localStorage.getItem("jwt") || "",
//       })
//     );
//   };

//   const handlePaymentChange = (
//     event: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     setPaymentGateway(event.target.value);
//   };

//   return (
//     <div className="pt-10 px-5 sm:px-10 md:px-44 lg:px-60 min-h-screen">
//       <div className="space-y-5 lg:space-y-0 lg:grid grid-cols-3 lg:gap-9">
//         <div className="col-span-2 space-y-5">
//           <div className="flex justify-between items-center gap-4">
//             <span className="font-semibold">Select Delivery Address</span>

//             <Button onClick={handleOpen} variant="outlined">
//               Add New Address
//             </Button>
//           </div>

//           <div className="text-xs font-medium space-y-5">
//             <p>Saved Addresses</p>

//             <div className="space-y-3">
//               {addresses.length > 0 ? (
//                 addresses.map((item, index) => (
//                   <AddressCard
//                     key={item.id || index}
//                     item={item}
//                     selectedValue={value}
//                     value={index}
//                     handleChange={handleChange}
//                   />
//                 ))
//               ) : (
//                 <div className="border border-gray-200 rounded-md p-5 text-sm text-gray-500">
//                   No saved address found. Please add a new address.
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="py-4 px-5 rounded-md border">
//             <Button onClick={handleOpen} startIcon={<AddIcon />}>
//               Add New Address
//             </Button>
//           </div>
//         </div>

//         <div className="col-span-1 text-sm space-y-3">
//           <section className="space-y-3 border p-5 rounded-md">
//             <h1 className="text-primary-color font-medium pb-2 text-center">
//               Choose Payment Gateway
//             </h1>

//             <RadioGroup
//               row
//               aria-labelledby="payment-gateway-group"
//               name="payment-gateway-group"
//               className="flex justify-between pr-0"
//               onChange={handlePaymentChange}
//               value={paymentGateway}
//             >
//               {paymentGatwayList.map((item) => (
//                 <FormControlLabel
//                   key={item.value}
//                   className={`border w-[45%] flex justify-center rounded-md pr-2 ${
//                     paymentGateway === item.value ? "border-primary-color" : ""
//                   }`}
//                   value={item.value}
//                   control={<Radio />}
//                   label={
//                     <div>
//                       <img
//                         className="object-cover"
//                         src={item.image}
//                         alt={item.label}
//                       />
//                     </div>
//                   }
//                 />
//               ))}
//             </RadioGroup>
//           </section>

//           <section className="border rounded-md">
//             <PricingCard />

//             <div className="p-5">
//               <Button
//                 onClick={handleCreateOrder}
//                 disabled={addresses.length === 0}
//                 sx={{ py: "11px" }}
//                 variant="contained"
//                 fullWidth
//               >
//                 Checkout
//               </Button>
//             </div>
//           </section>
//         </div>
//       </div>

//       <Modal
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="address-modal-title"
//         aria-describedby="address-modal-description"
//       >
//         <Box sx={style}>
//           <AddressForm
//             paymentGateway={paymentGateway}
//             handleClose={() => {
//               handleClose();
//               dispatch(fetchUserAddresses());
//             }}
//           />
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default AddressPage;


import React, { useEffect, useState } from "react";
import PricingCard from "../Cart/PricingCard";
import {
  Box,
  Button,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import AddressForm from "./AddresssForm";
import AddressCard from "./AddressCard";
import AddIcon from "@mui/icons-material/Add";
import { createOrder } from "../../../Redux Toolkit/Customer/OrderSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import {
  addUserAddress,
  fetchUserAddresses,
} from "../../../Redux Toolkit/Customer/UserSlice";
import { Address } from "../../../types/userTypes";

const style = {
  position: "fixed" as const,
  top: "52%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "calc(100% - 24px)",
  maxWidth: "620px",
  outline: "none",
  bgcolor: "transparent",
  boxShadow: "none",
  p: 0,
  overflow: "hidden",
};

const paymentGatwayList = [
  {
    value: "RAZORPAY",
    image:
      "https://razorpay.com/newsroom-content/uploads/2020/12/output-onlinepngtools-1-1.png",
    label: "Razarpay",
  },
];

const AddressPage = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((store) => store);

  const addresses =
    user.addresses && user.addresses.length > 0
      ? user.addresses
      : user.user?.addresses || [];

  const defaultAddressIndex = addresses.findIndex(
    (address: Address) => address.defaultAddress
  );

  const [value, setValue] = useState(
    defaultAddressIndex >= 0 ? defaultAddressIndex : 0
  );
  const [paymentGateway, setPaymentGateway] = useState(
    paymentGatwayList[0].value
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const jwt = localStorage.getItem("jwt") || "";

    if (jwt) {
      dispatch(fetchUserAddresses({ jwt }));
    }
  }, [dispatch]);

  useEffect(() => {
    const newDefaultAddressIndex = addresses.findIndex(
      (address: Address) => address.defaultAddress
    );

    if (newDefaultAddressIndex >= 0) {
      setValue(newDefaultAddressIndex);
    } else if (addresses.length > 0 && value >= addresses.length) {
      setValue(0);
    }
  }, [addresses.length, value]);

  const handleOpen = () => {
    setOpen(true);
    document.body.style.overflow = "hidden";
  };

  const handleClose = () => {
    setOpen(false);
    document.body.style.overflow = "";
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(event.target.value));
  };

  const handleCreateOrder = () => {
    const selectedAddress = addresses[value];

    if (!selectedAddress) {
      return;
    }

    dispatch(
      createOrder({
        paymentGateway,
        address: selectedAddress,
        jwt: localStorage.getItem("jwt") || "",
      })
    );
  };

  const handlePaymentChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPaymentGateway(event.target.value);
  };

  const handleAddressSubmit = async (address: Address) => {
    const jwt = localStorage.getItem("jwt") || "";

    if (!jwt) return;

    await dispatch(addUserAddress({ jwt, address }));
    await dispatch(fetchUserAddresses({ jwt }));

    handleClose();
  };

  return (
    <div className="pt-10 px-5 sm:px-10 md:px-44 lg:px-60 min-h-screen">
      <div className="space-y-5 lg:space-y-0 lg:grid grid-cols-3 lg:gap-9">
        <div className="col-span-2 space-y-5">
          <div className="flex justify-between items-center gap-4">
            <span className="font-semibold">Select Delivery Address</span>

            <Button onClick={handleOpen} variant="outlined">
              Add New Address
            </Button>
          </div>

          <div className="text-xs font-medium space-y-5">
            <p>Saved Addresses</p>

            <div className="space-y-3">
              {addresses.length > 0 ? (
                addresses.map((item: Address, index: number) => (
                  <AddressCard
                    key={item.id || index}
                    item={item}
                    selectedValue={value}
                    value={index}
                    handleChange={handleChange}
                  />
                ))
              ) : (
                <div className="border border-gray-200 rounded-md p-5 text-sm text-gray-500">
                  No saved address found. Please add a new address.
                </div>
              )}
            </div>
          </div>

          <div className="py-4 px-5 rounded-md border">
            <Button onClick={handleOpen} startIcon={<AddIcon />}>
              Add New Address
            </Button>
          </div>
        </div>

        <div className="col-span-1 text-sm space-y-3">
          <section className="space-y-3 border p-5 rounded-md">
            <h1 className="text-primary-color font-medium pb-2 text-center">
              Choose Payment Gateway
            </h1>

            <RadioGroup
              row
              aria-labelledby="payment-gateway-group"
              name="payment-gateway-group"
              className="flex justify-between pr-0"
              onChange={handlePaymentChange}
              value={paymentGateway}
            >
              {paymentGatwayList.map((item) => (
                <FormControlLabel
                  key={item.value}
                  className={`border w-[45%] flex justify-center rounded-md pr-2 ${
                    paymentGateway === item.value ? "border-primary-color" : ""
                  }`}
                  value={item.value}
                  control={<Radio />}
                  label={
                    <div>
                      <img
                        className="object-cover"
                        src={item.image}
                        alt={item.label}
                      />
                    </div>
                  }
                />
              ))}
            </RadioGroup>
          </section>

          <section className="border rounded-md">
            <PricingCard />

            <div className="p-5">
              <Button
                onClick={handleCreateOrder}
                disabled={addresses.length === 0}
                sx={{ py: "11px" }}
                variant="contained"
                fullWidth
              >
                Checkout
              </Button>
            </div>
          </section>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        disableScrollLock
        aria-labelledby="address-modal-title"
        aria-describedby="address-modal-description"
      >
        <Box sx={style}>
          <AddressForm
            mode="profile"
            paymentGateway={paymentGateway}
            handleClose={handleClose}
            onAddressSubmit={handleAddressSubmit}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default AddressPage;